import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getDistribuidores } from 'services/comerciantes'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_DISTRIBUIDORES() {
  try {
    const distribuidoresData = yield call(getDistribuidores)
    if (distribuidoresData.ok) {
      yield put({
        type: actions.DISTRIBUIDORES_LOAD_SUCCEEDED,
        payload: distribuidoresData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar distribuidores')
      put({
        type: actions.DISTRIBUIDORES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DISTRIBUIDORES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.DISTRIBUIDORES_LOAD_REQUESTED, GET_DISTRIBUIDORES)])
}
